import { useEffect, useState, useRef } from "react";
import { useLocation } from 'react-router-dom';
import { TooltipComponentMobile, TooltipComponent } from "../../Tooltip";

const PersonalizedFit = ({ user, resetStateToggle, setFitFilter, setFitParams, mobile }) => {

  const location = useLocation()
  const [selectedFit, setSelectedFit] = useState<any>(0)
  // 3. user class rank check
  // user's gpaWunweighted and either classRankNumber or classRankTier must be non-null. from data val, classRankSize would be null if classRankNumber is null
  // const userPreReq = (user && (user?.gpaUnweighted || (user?.classRankNumber || user?.classRankTier)))
  const [userPreReq, setUserPreReq] = useState(!!(user && (user.gpaUnweighted != null || user.classRankNumber != null || user.classRankTier != null)))
  const isFirstRender = useRef(true);

  const fitOptions = [
    { key: 'All', value: 0 },
    { key: 'Reach', value: 1 },
    { key: 'Target', value: 2 },
    { key: 'Safety', value: 3 },
    { key: 'Unknown', value: 5 },
  ]

  useEffect(() => {
    setUserPreReq(!!(user && (user.gpaUnweighted != null || user.classRankNumber != null || user.classRankTier != null)))
  }, [user]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setFitFilter(0);
    setSelectedFit(0);
  }, [resetStateToggle]);

  useEffect(() => {

    let params = new URLSearchParams(location.search);
    let fitParam = params.get('fit');

    if (fitParam) {
      setFitFilter(parseInt(fitParam));
      setSelectedFit(parseInt(fitParam))
    }

  }, [location.search]);

  useEffect(() => {
    let params = new URLSearchParams(location.search);

    if (selectedFit != null && selectedFit > 0) {
      params.set('fit', selectedFit)
    } else {
      params.delete('fit')
    }

    setFitParams(`${params.toString()}`)
  }, [selectedFit])

  const userTrue = (
    <div className='mt-4 d-flex flex-column' style={{ marginTop: '15px' }}>
      <div className={`dca-aside-header ${mobile ? 'd-flex flex-row' : ''}`}>PERSONAL FIT {mobile ? <span className="ms-2"><TooltipComponentMobile content={"NextFour estimates each college's fit (Reach, Target, or Safety) based on your individual profile and displays the personalized indication with each result. This is a preliminary assessment; you may adjust the classification for any college by adding to your interest list and editing on the user profile page."} /></span> : <TooltipComponent content={"NextFour estimates each college's fit (Reach, Target, or Safety) based on your individual profile and displays the personalized indication with each result. This is a preliminary assessment; you may adjust the classification for any college by adding to your interest list and editing on the user profile page."} />}</div>
      <select
        className='form-select form-select-solid'
        data-control="select2"
        value={selectedFit}
        onChange={(e) => {
          setFitFilter(e.target.value);
          setSelectedFit(e.target.value)
        }}
        style={{ cursor: 'pointer' }}
      >{fitOptions.map((opt) => <option value={opt.value}>{opt.key}</option>)}
      </select>
      <span className="dca-edit-user-profile-span-modal-trigger mt-3" data-bs-toggle="modal"
        data-bs-target="#editUserProfile">Edit User Profile</span>
    </div>
  )

  const userFalse = user ? (
    <div className='mt-4 d-flex flex-column' style={{ marginTop: '15px' }}>
      <div className={`dca-aside-header ${mobile ? 'd-flex flex-row' : ''}`}>PERSONAL FIT {mobile ? <span className="ms-2"><TooltipComponentMobile content={"NextFour estimates each college's fit (Reach, Target, or Safety) based on your individual profile. Please click the link to enter your profile details and view your personalized fit indicators."} /></span> : <TooltipComponent content={"NextFour estimates each college's fit (Reach, Target, or Safety) based on your individual profile. Please click the link to enter your profile details and view your personalized fit indicators."} />}</div>
      <div
        className='form-select form-select-solid dca-personal-fit-userFalse'
        data-bs-toggle="modal"
        data-bs-target="#editUserProfile"
        style={{ cursor: 'pointer' }}
      >Enter User Data
      </div>
    </div>
  ) : (
    <div className='mt-4 d-flex flex-column' style={{ marginTop: '15px' }}>
      <div className={`dca-aside-header ${mobile ? 'd-flex flex-row' : ''}`}>PERSONAL FIT {mobile ? <span className="ms-2"><TooltipComponentMobile content={"NextFour estimates each college's fit (Reach, Target, or Safety) based on your individual profile. Please sign-in to your account to view personalized fit indicators."} /></span> : <TooltipComponent content={"NextFour estimates each college's fit (Reach, Target, or Safety) based on your individual profile. Please sign-in to your account to view personalized fit indicators."} />}</div>
      <div
        className='form-select form-select-solid dca-personal-fit-userFalse'
        data-bs-toggle="modal"
        data-bs-target="#login_modal"
        style={{ cursor: 'pointer' }}
      >Sign in
      </div>
    </div>
  )

  return userPreReq ? userTrue : userFalse
}


export { PersonalizedFit }